import { useAppSelector } from 'hooks/redux.hooks';
import { selectImageUrl } from 'state/reducers/translation.reducers';
//MUI
import { GeneralButton, FormButton } from 'theme/elements/Buttons';
//theme
import { HeaderPage4 } from 'theme/elements/Headers';
import { CenteredText } from 'theme/elements/Content';
import { Box, Button, Stack } from '@mui/material';
import Add from '@mui/icons-material/Add';
import { getCompanyPlanId } from 'state/reducers/user.reducers';

export type propsType = {
	title: string;
	text?: string;
	onclick?: () => void;
	noAction?: boolean;
	addLabel?: string;
	imageKey: string;
	startIcon?: string;
};

export default function CreateMessage(props: propsType) {
	const imageUrl = useAppSelector(selectImageUrl);
	const companyPlan = useAppSelector(getCompanyPlanId);

	return (
		<Box sx={{ marginTop: '48px' }}>
			<CenteredText>
				<Stack spacing={4}>
					<Box>
						<img src={imageUrl(props.imageKey) || '/static_images/brand-image-4.svg'} />
					</Box>
					<HeaderPage4 title={props.title} text={props.text} />
					{!props.noAction && !companyPlan?.isDefault && (
						<FormButton>
							<GeneralButton>
								<Button
									variant="contained"
									onClick={props.onclick}
									startIcon={
										imageUrl(`${props.startIcon}`) ? (
											<img
												src={imageUrl(`${props.startIcon}`)}
												style={{ height: '24px', width: '24px' }}
											/>
										) : (
											<Add sx={{ '&.MuiSvgIcon-root': { height: '24px', width: '24px' } }} />
										)
									}
								>
									{props.addLabel || 'ADD NEW'}
								</Button>
							</GeneralButton>
						</FormButton>
					)}
				</Stack>
			</CenteredText>
		</Box>
	);
}
